

$("body").on("click", ".cat-list .open-child", function(e) {
  e.preventDefault()
  // $(this).parent().find('.grand-child').slideToggle();
  $(this).next().slideToggle();
  $(this).toggleClass('open');
})

$('body').on('click','.trigger-html-download',function () {
  $('.download-html').click()
})


$('body').on('click','.trigger-ajax',function () {

  $(this).removeClass('trigger-ajax')
  $.get(
    YNA_ADMIN.ajaxUrl,
    {
      action: 'getDownload',
      id:$(this).data('id'),
      show:$(this).data('show'),

    },
    function(response) {

      $('.ajax-return').html(response);

    }
  );
})

$("body").on("click", ".wrap-tab-title-icon", function() {
  if($(this).hasClass('open')){
    $(this).removeClass('open')
    $(this).next().slideUp(150)
  }else {
    $(this).addClass('open')
    $(this).next().slideDown(150);
  }
})


$('.filters a').click(function () {
  $('.loading-full').show()
    let type = $(this).data('id');
    getList(type);
    $('.filters a').removeClass('is-active');
    $(this).addClass('is-active')
})

if($('body').hasClass('tax-products_cat') || $('body').hasClass('single-products')) {
  let type = $('.filters a.is-active').data('id');
  if(window.location.hash) {

    let hashVal = window.location.hash.replace("#", "");
     if(hashVal == 'by_series' || hashVal == 'by_application' || hashVal == 'by_pressure'){
       type = hashVal;
       $('.filters a').removeClass('is-active');
       $('.filters a').each(function () {
          if($(this).data('id') == type){
            $(this).addClass('is-active')
          }
       })
     }

  }


  getList(type)
}

function getList(type) {

  let term = ''

  var url_string = window.location.href
  var url = new URL(url_string);
  var termCheck = url.searchParams.get("term");

  if(termCheck){
    term = termCheck
  }


  $.get(
    YNA_ADMIN.ajaxUrl,
    {
      action: 'filterData',
      type: type,
      term: term,
      category: $('#current').data('current').id,
      current: $('#current').data('current'),

    },
    function(response) {
      $('.cat-list').html(response);
      $('.loading-full').hide();

        $('.active-cat').parents('ul').slideDown()

      if(window.location.hash) {
        // smooth scroll to the anchor id
        let height = $('.logo').height() + $('.top-bar').height()+50;
        $('html, body').animate({
          scrollTop: $(`[data-id="${window.location.hash}"]`).offset().top-height + 'px',
        }, 1000, 'swing');
      }
    }
  );
}




// WEBPACK FOOTER //
// ./scripts/routes/product.js